<script setup lang="ts">
import { computed } from 'vue';
import { Direction } from '@enums/direction.ts';

const props = withDefaults(defineProps<{
  panelClass?: string,
  triggerClass?: string,
  direction?: Direction,
}>(), {
  panelClass: '',
  triggerClass: '',
  direction: Direction.DOWN,
});

const directionVariant = computed<string>(() => props.direction.toLowerCase());
</script>

<template>
  <div
    class="v-tooltip"
    :class="`v-tooltip--${directionVariant}`"
  >
    <div class="v-tooltip__trigger" :class="triggerClass">
      <slot name="trigger" />
    </div>

    <div
      class="v-tooltip__panel"
      :class="[
        `v-tooltip__panel--${directionVariant}`,
        panelClass,
        { 'v-tooltip__panel--up': direction === Direction.UP }
      ]"
    >
      <slot name="panel" />
    </div>
  </div>
</template>
